import { render, staticRenderFns } from "./ReadyToBeMade.vue?vue&type=template&id=2acf023d&scoped=true"
import script from "./ReadyToBeMade.vue?vue&type=script&lang=js"
export * from "./ReadyToBeMade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acf023d",
  null
  
)

export default component.exports